import {
  ActivatePartnerOfferError,
  ActivatePartnerOfferResultTypenames,
  ActivatePartnerOfferSuccess,
  ActivationMaximumReached,
  DailyRedemptionMaxReached,
  Mutation,
} from '@varo/graphql-schema-types';

export type ActivatePartnerOfferResult = Mutation['activatePartnerOffer'];

export const isActivationSuccess = (
  result?: ActivatePartnerOfferResult,
): result is ActivatePartnerOfferSuccess =>
  result?.__typename ===
  ActivatePartnerOfferResultTypenames.ActivatePartnerOfferSuccess;

export const isActivationError = (
  result?: ActivatePartnerOfferResult,
): result is ActivatePartnerOfferError =>
  result?.__typename ===
  ActivatePartnerOfferResultTypenames.ActivatePartnerOfferError;

export const isActivationMaximumReached = (
  result?: ActivatePartnerOfferResult,
): result is ActivationMaximumReached =>
  result?.__typename ===
  ActivatePartnerOfferResultTypenames.ActivationMaximumReached;

export const isDailyRedemptionMaxReached = (
  result?: ActivatePartnerOfferResult,
): result is DailyRedemptionMaxReached =>
  result?.__typename ===
  ActivatePartnerOfferResultTypenames.DailyRedemptionMaxReached;
